// extracted by mini-css-extract-plugin
export default {"hideIcons":"ReceiptPage_hideIcons__dBuUN","receiptPage":"ReceiptPage_receiptPage__nFeBP","container":"ReceiptPage_container__cuvfo","receiptBlock":"ReceiptPage_receiptBlock__Pv6js"};